import { Card } from '@pco/atoms/Card';
import { getDataAttrs } from '@pco/utils';
import styled from 'styled-components';

const dataAttrs = getDataAttrs(['molecule', 'detail-card']);

const CategoryCardContainer = styled.div.attrs(dataAttrs('root'))`
  display: flex;
  flex-direction: column;
  justify-content: start;
`;

const CardTitle = styled.div.attrs(dataAttrs('title'))`
  ${({ theme: { typography } }) => {
		return `
      ${typography.body16};
      font-weight: 600;
    `;
	}}
`;

const CardSubtitle = styled.div`
  ${({ theme: { semanticTokens, typography } }) => {
		return `
      margin-top: 4px;
      color: ${semanticTokens.colors.content.secondary};
      ${typography.body16};
    `;
	}}
`;

const FocusedContent = styled(Card)`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  overflow: hidden;
  flex-shrink: 0;
  flex-grow: 1;
`;

export const DetailedCard = Object.assign(CategoryCardContainer, {
	Content: FocusedContent,
	Title: CardTitle,
	Subtitle: CardSubtitle,
});
